import React from 'react';
import Pageheader from '../utils/headerHelment';
import WorkspaceSettings from '../components/WorkspaceSettings';

const WorkspaceSettingsPage = () => {
    return (
        <>
            <Pageheader title="LENS - Workspace Settings" />
            <WorkspaceSettings />
        </>
    );
};

export default WorkspaceSettingsPage;

